import React, { useEffect, useState } from "react"
import { useFormikContext } from "formik"
import { FieldError, useFieldCSSClasses } from "./FieldError"
import useHideAndShowField from "./hooks/useHideAndShowField"
import { isRLTLang } from "src/i18n"
import { FormattedError } from "../../alerts/FormattedError";
import { getAttr } from "src/helpers"
import { isFunction } from "lodash"
import { isArray, isEmpty, isString } from "lodash"
import _ from "lodash";

const InputNumberField = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  unit = '',
  inputGroupClassName = "form-group",
  inputClassName = "form-control",
  backgroundColor = '#FAFAFA',
  type = "text",
  required = false,
  disabled = false,
  maxLength = 256,
  form,
  error,
  hide=false,
  hideOnFields=[],
  relyOn,
  formRepeaterRelyOn=false,
  size = 12,
  placeholder,
  loadValue,
  emit,
  formatter = null, // function to format the value before displaying
  displayValue, // custom display value that overrides field.value
  ...props
}) => {
  const unitStyle = isRLTLang() ? {
    position: "absolute",
    height: '1.125rem',
    minWidth: '1.25rem',
    paddingTop: '.375rem',
    left: '1.375rem'
  } : {
    position: "absolute",
    height: '1.125rem',
    minWidth: '1.25rem',
    paddingTop: '.375rem',
    right: '1.375rem'
  }
//  const [inputs, setInputs] = useState("")
  
  const formik = useFormikContext()
  const conditionalShowAndHideClassName = useHideAndShowField({ formik, fieldName: field.name,formRepeaterRelyOn: formRepeaterRelyOn, hideOnFields: hideOnFields, ...props })
  const fieldCSSClasses = useFieldCSSClasses(touched, errors, field.name)

  useEffect(() => {
    let val;
  
    if (isFunction(loadValue)) {
        let relyOnName=null
        let val=null
       if (formRepeaterRelyOn) {
       const [formRepeaterName,index] = field.name.split('.');
       relyOnName = formRepeaterName+"["+index+"]."+relyOn
       val=loadValue(formik.values,relyOnName)
      }
       else {
        val=loadValue(formik.values)
       }
      val = loadValue(formik.values,relyOnName)
      form.setFieldValue(field.name, val)
      formik.setFieldValue(field.name, val)
    
    }
    //  eslint-disable-next-line
  }, [formik.values])
  useEffect(() => {
    if (_.isFunction(emit)){
      emit({type:`CHANGE_${field.name.toUpperCase()}`,payload:field.value})
    }
  }, [field.value]);
  return (
    <>
    { !hide && <div style={{ width: '100%' }} className={inputGroupClassName + conditionalShowAndHideClassName + ` col-lg-${size}`}>
      {label && <label className="custom-label-style"> {label} <span>{(required && "*")}</span></label>}
      {unit && <div style={unitStyle}  >{unit} </div>}
      <input
  style={{ backgroundColor, height: "40px" }}
  type={type}
  inputMode={type === "number" ? "numeric" : undefined}
  disabled={disabled}
  className={`${inputClassName} ${fieldCSSClasses} ${disabled && `disabled`}`}
  maxLength={maxLength}
  autoComplete="off"
  placeholder={placeholder}
  {...field}
  value={
    displayValue !== undefined
      ? displayValue
      : (!_.isNull(formatter)
          ? formatter(formik.values)
          : field.value ? field.value : "")
  }
  onChange={(e) => {
    let value = e.target.value;
  
    // allow only numbers when type === "number"
    if (type === "number") {
      value = value.replace(/\D/g, "");
    }
  
    // enforce maxlength manually
    if (maxLength) {
      value = value.slice(0, maxLength);
    }
  
    formik.setFieldValue(field.name, value);
  }}
/>
      {error ? <FormattedError message={error} onClose={null} /> : <></>}
      <FieldError fieldName={field.name} />
    </div>}</>
  )
}

export default InputNumberField
